import React from 'react'

export default function ErrorPage() {
    return (
        <div>
            <h1>404! Not Found</h1>
        </div>
    )
}
